import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TeamPage from "./pages/TeamPage";
import PlayerPage from "./pages/PlayerPage";
import ThankYouPage from "./pages/ThankYouPage";
import CoachLogin from "./coach/CoachLogin";
import CoachLayout from "./coach/CoachLayout";
import Dashboard from "./coach/Dashboard";
import PlayersManagement from "./coach/PlayersManagement";
import DonorList from "./coach/DonorList";
import Goals from "./coach/Goals";
import ThankYou from "./coach/ThankYou";
import Schedule from "./coach/Schedule";
import ProtectedRoute from "./coach/ProtectedRoute";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/" element={<TeamPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/player/:id" element={<PlayerPage />} />
        <Route path="/thank-you/:playerId" element={<ThankYouPage />} />

        {/* Coach */}
        <Route path="/coach" element={<CoachLogin />} />
        <Route
          element={
            <ProtectedRoute>
              <CoachLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/coach/dashboard" element={<Dashboard />} />
          <Route path="/coach/players" element={<PlayersManagement />} />
          <Route path="/coach/donors" element={<DonorList />} />
          <Route path="/coach/goals" element={<Goals />} />
          <Route path="/coach/schedule" element={<Schedule />} />
          <Route path="/coach/thank-you" element={<ThankYou />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
